import React, { Dispatch, SetStateAction } from "react";

import { MobileSubHeader as BasicSubHeader } from "~components";
type SubHeaderProps = {
  showSearch: boolean;
  toggleSearch: () => void;
  setSearch: Dispatch<SetStateAction<string>>;
  hasBackground?: boolean;
};

export const SubHeader = ({
  showSearch,
  toggleSearch,
  setSearch,
  hasBackground,
}: SubHeaderProps) => {
  return (
    <BasicSubHeader>
      <></>
    </BasicSubHeader>
  );
};
